import { NotificationType } from '../enums';

export const NotificationStatusMapper: Record<NotificationType, string> = {
  [NotificationType.GameApplicationApproved]: 'Twoja prośba o gierkę została zaakceptowana!',
  [NotificationType.GameApplicationRejected]: 'Twoja prośba została odrzucona.',
  [NotificationType.GameReminder]: 'Twoja gierka zaczyna się za chwilę!',
  [NotificationType.HostedGameReminder]: 'Gierka którą organizujesz zaczyna się za chwilę!',
  [NotificationType.GameCanceled]: 'Twoja gierka została odwołana',
  [NotificationType.GameUpdated]: 'Twoja gierka została zaktualizowana',
  [NotificationType.HostedGameNewApplication]: 'Masz nową prośbę o gierkę!',
  [NotificationType.HostedGamePlayerLeft]: 'Gracz opuścił Twoją gierkę.',
  [NotificationType.NewGameByAlert]: 'Nowa gierka w Twojej okolicy!',
  [NotificationType.GameFinished]: 'Gierka zakończona! Zobacz szczegóły płatności.',
  [NotificationType.HostedGameFinished]: 'Twoja gierka została zakończona!',
  [NotificationType.GamePlayerRemovedByHost]: 'Zostałeś usunięty z gierki.',
  [NotificationType.GameInvitationRecived]: 'Dostałeś zaproszenie do gierki!',
  [NotificationType.ChatNewMessage]: 'Dostałeś nową wiadomość!',
  [NotificationType.CustomNotification]: 'Zobacz newsa!',
  [NotificationType.HostedGamePlayerAutoApproved]: 'Gracz został automatycznie zaakceptowany!',
  [NotificationType.TeamMemberAddedByHost]: 'Witaj w grupce!',
  [NotificationType.UserPenaltyReceived]: 'Otrzymałeś kartkę!',
  [NotificationType.GameLineupsCreated]: 'Składy zostały wylosowane! Sprawdź z kim grasz!',
  [NotificationType.NewTrophyReceived]: 'Zdobyłeś nowe osiągnięcie!',
  [NotificationType.NewCommentReceived]: 'Dostałeś nowy komplement!',

  // Player
  [NotificationType.ActionPushPlayerCollectPoints]: 'Zbieraj punkty i wymieniaj je na zniżki!',
  [NotificationType.ActionPushPlayerInvitePlayers]: 'Zaproś kumpli i zbierz punkty!',
  [NotificationType.ActionPushPlayerInactive]: 'Dlaczego jeszcze nie zagrałeś? Boisko czeka!',
  [NotificationType.ActionPushPlayerAchievements]: 'Wyróżnij się w swoim mieście!',
  [NotificationType.ActionPushPlayerInactive2]: 'Długo nie było Cię na boisku! Czas to zmienić!',
  [NotificationType.ActionPushPlayerAlerts]: 'Niech gierki znajdują się same!',

  // Player after action
  [NotificationType.ActionPushPlayerCommentsAndPenalties]: 'Dowiedz się czym są komplementy i kartki!',

  // Host
  [NotificationType.ActionPushHostCollectPoints]: 'Zbieraj punkty i wymieniaj je na zniżki!',
  [NotificationType.ActionPushHostInvitePlayers]: 'Zaproś kumpli i zbierz punkty!',
  [NotificationType.ActionPushHostInactive]: 'Stwórz swoją pierwszą gierkę w Orlikfy!',
  [NotificationType.ActionPushHostAchievements]: 'Wyróżnij się jako organizator w swoim mieście!',

  // Host after action
  [NotificationType.ActionPushHostTeamsDrawing]: 'Nie wiesz, jak podzielić zespoły? Sprawdź losowanie składów!',
  [NotificationType.ActionPushHostCommentsAndPenalties]: 'Za dobre nagradzaj, za złe karaj!',
  [NotificationType.ActionPushHostCreateGroup]: 'Masz stałą ekipę? Stwórz swoją grupkę!',
  [NotificationType.ActionPushHostInvitePreviousPlayers]: 'Brakuje Ci zawodników na gierkę? Zaproś dawnych graczy!'
};
